import React from 'react';
import { connect } from 'react-redux';
import { MenuItem, ListItemText, ListItemIcon } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { createActions } from '../../store';
import CheckIcon from '@mui/icons-material/CheckRounded';
import { PREVIEW_RESOLUTION } from '../../Preview/PreviewDisplayConstants';

const styles = theme => ({
    previewSettingMenuItemIcon: {
        minWidth: theme.spacing(5)
    },
    previewSettingMenuItemText: {
        textAlign: 'right'
    }
});

const PreviewQualitySelect = (props) => {
    const { classes, previewResolution, setPreviewResolution } = props;

    return (
        <>
            <MenuItem 
                onClick={() => setPreviewResolution(PREVIEW_RESOLUTION.SEVEN_TWENTY)}
                selected={previewResolution === PREVIEW_RESOLUTION.SEVEN_TWENTY}
            >
                <ListItemIcon className={classes.previewSettingMenuItemIcon}>
                    <CheckIcon style={{visibility: previewResolution === PREVIEW_RESOLUTION.SEVEN_TWENTY ? null : 'hidden'}}/>
                </ListItemIcon>
                <ListItemText className={classes.previewSettingMenuItemText}>
                    720p
                </ListItemText>
            </MenuItem>
            <MenuItem 
                onClick={() => setPreviewResolution(PREVIEW_RESOLUTION.FOUR_EIGHTY)}
                selected={previewResolution === PREVIEW_RESOLUTION.FOUR_EIGHTY}
            >
                <ListItemIcon className={classes.previewSettingMenuItemIcon}>
                    <CheckIcon style={{visibility: previewResolution === PREVIEW_RESOLUTION.FOUR_EIGHTY ? null : 'hidden'}}/>
                </ListItemIcon>
                <ListItemText className={classes.previewSettingMenuItemText}>
                    480p
                </ListItemText>
            </MenuItem>
            <MenuItem 
                onClick={() => setPreviewResolution(PREVIEW_RESOLUTION.THREE_SIXTY)}
                selected={previewResolution === PREVIEW_RESOLUTION.THREE_SIXTY}
            >
                <ListItemIcon className={classes.previewSettingMenuItemIcon}>
                    <CheckIcon style={{visibility: previewResolution === PREVIEW_RESOLUTION.THREE_SIXTY ? null : 'hidden'}}/>
                </ListItemIcon>
                <ListItemText className={classes.previewSettingMenuItemText}>
                    360p
                </ListItemText>
            </MenuItem>
            <MenuItem 
                onClick={() => setPreviewResolution(PREVIEW_RESOLUTION.TWO_FORTY)}
                selected={previewResolution === PREVIEW_RESOLUTION.TWO_FORTY}
            >
                <ListItemIcon className={classes.previewSettingMenuItemIcon}>
                    <CheckIcon style={{visibility: previewResolution === PREVIEW_RESOLUTION.TWO_FORTY ? null : 'hidden'}}/>
                </ListItemIcon>
                <ListItemText className={classes.previewSettingMenuItemText}>
                    240p
                </ListItemText>
            </MenuItem>
        </>
    );
};

const mapStateToProps = (state) => {
    const { previewResolution } = state.create;
    return { previewResolution };
}

const mapDispatchToProps = (dispatch) => {
    const setPreviewResolution = (resolution) => dispatch(createActions.setPreviewResolution(resolution));
    return { setPreviewResolution }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(PreviewQualitySelect, styles));